<script setup>
import { computed } from 'vue';
import { cn } from 'dashboard/components-next/ui-shadcn/utils';

const props = defineProps({
  class: { type: [String, Array, Object], default: '' },
});

const classes = computed(() =>
  cn(
    'rounded-2xl border border-n-weak bg-n-solid-1 dark:bg-n-solid-2 shadow-sm flex flex-col',
    props.class
  )
);
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
